import { render } from "./TabAcomodacoes.vue?vue&type=template&id=44082f04&scoped=true"
import script from "./TabAcomodacoes.vue?vue&type=script&lang=js"
export * from "./TabAcomodacoes.vue?vue&type=script&lang=js"

import "./TabAcomodacoes.vue?vue&type=style&index=0&id=44082f04&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44082f04"]])

export default __exports__